import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface TableSportsWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setTableSportsWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.medium};
        `;
    }
    return css``;
};

export const TableSportsWrapper = withConfig(theme => styled('div', { label: 'TableSportsWrapper' })<TableSportsWrapperPropsType>`
    ${({ variant }): SerializedStyles => setTableSportsWrapper(variant, theme)}
    width: 100%;
`);

interface TableSportItemsPropsType {
    isOpen: boolean;
    variant: DefaultComponentVariantType | null;
    columns: number;
}

const setTableSportItems = (variant: DefaultComponentVariantType | null, theme: EmotionTheme, isOpen: boolean, columns: number): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            gap: ${theme.star.gap.small};
            display: ${isOpen ? 'grid' : 'none'};
            grid-template-columns: 1fr;
            @media ${theme.star.mediaQuery.tablet} {
                grid-template-columns: repeat(${columns}, 1fr);
            }
        `;
    }
    return css`
        border-color: ${theme.star.meetingsAntePost.borderColor};
        border-style: solid;
        border-width: 1px 0 0;
        flex-flow: row wrap;
        display: ${isOpen ? 'flex' : 'none'};
        @media ${theme.star.mediaQuery.tablet} {
            border-width: 1px;
        }
    `;
};

export const TableSportItems = withConfig(theme => styled('div', { label: 'TableSportItems' })<TableSportItemsPropsType>`
    ${({ variant, isOpen, columns }): SerializedStyles => setTableSportItems(variant, theme, isOpen, columns)}
`);
